exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div[data-v-51e1ba73]{cursor:not-allowed}input[data-v-51e1ba73]{pointer-events:none;border-color:rgb(207.5,207.5,207.5)!important}", ""]);

// exports
